import type { AuditEntry } from '../../api/monitor';
import { actorInitials, auditWhen } from '../../lib/audit';

/**
 * Uma ação registrada: quem, o quê, sobre o quê e quando.
 *
 * A frase fica em uma linha só ("**Ana Beatriz** gerou relatório de consumo")
 * porque é assim que se lê o histórico de cima para baixo; o alvo desce para a
 * segunda linha, onde pode ser longo sem quebrar o alinhamento das demais.
 */
export function AuditRow({ entry }: { entry: AuditEntry }) {
  return (
    <div className="border-surface-200 flex items-center gap-2.5 border-b px-4 py-3 last:border-b-0">
      <div
        className="bg-surface-300 flex size-[30px] shrink-0 items-center justify-center rounded-full text-[11px] font-extrabold text-[#3A4B6B]"
        aria-hidden="true"
      >
        {actorInitials(entry.actor)}
      </div>

      <div className="min-w-0 flex-1">
        <div className="text-[13px]">
          {/* O e-mail no title desempata dois homônimos sem alargar a linha. */}
          <b title={entry.actorEmail ?? undefined}>{entry.actor}</b> {entry.actionLabel}
        </div>
        {entry.target ? (
          <div className="text-ink-400 mt-px text-[11.5px]">{entry.target}</div>
        ) : null}
      </div>

      <span className="text-ink-400 shrink-0 text-[11px]">{auditWhen(entry.createdAt)}</span>
    </div>
  );
}
